import React, { useEffect } from "react";
import { IconButton } from "@mui/material";
import { RiFileExcel2Fill } from "react-icons/ri";

import { useDispatch, useSelector } from "react-redux";
import { getExcelList } from "../../store/actions/CheckItemGroupExcelActions";

export default function CheckItemGroupExcelToList(props) {
    const dispatch = useDispatch();

    const { CheckItemGroupExcel } = useSelector((state) => state);

    useEffect(() => {
        if (CheckItemGroupExcel?.excelList) {
            props.callBackTabData(props.tabId, CheckItemGroupExcel);
        }
    }, [CheckItemGroupExcel]);

    const checkFile = (event) => {
        if (event.target.files && event.target.files[0]) {
            let file = event.target.files[0];
            const formData = new FormData();
            formData.append("file", file);

            props.setFormData(formData);

            let payload = {
                data: formData,
                tabId: props.tabId,
            };

            dispatch(getExcelList(payload));
        }
    };

    return (
        <div>
            <IconButton
                id="cige_IconButton"
                component="label"
                disabled={props.disableExcel}
                size="large">
                <RiFileExcel2Fill id="cige_CreateNewFolder" style={{ width: 50, height: 50, fill: props.disableExcel ? "#bdbdbd" : "green" }} />
                <input id="cige_input" onChange={checkFile} type="file" style={{ display: "none" }} />
            </IconButton>
        </div>
    );
}
